<div
  ngbDropdown
  display="dynamic"
  placement="bottom-end"
>
  <button
    type="button"
    class="nav-link text-dark btn btn-link p-0 border-0 d-flex flex-column align-items-center"
    id="theme-menu"
    ngbDropdownToggle
    data-testid="themeMenuBtn"
    [attr.aria-label]="'Theme: ' + selectedOption().label"
    [title]="'Theme: ' + selectedOption().label"
  >
    <lib-svg-icon
      class="svg-24 text-colour-grayscale-900"
      [icon]="selectedOption().icon"
      [stroke]="true"
    />
    <div class="d-flex gap-1 align-items-center">
      Theme
      <lib-svg-icon
        icon="chevron-down-filled"
        class="svg-8-no-pad text-colour-grayscale-900"
        [fill]="true"
      />
    </div>
  </button>
  <div
    ngbDropdownMenu
    aria-labelledby="theme-menu"
  >
    @for (option of options; track option.value) {
      <button
        type="button"
        ngbDropdownItem
        class="d-flex align-items-center gap-2"
        [class.active]="preference() === option.value"
        [attr.aria-pressed]="preference() === option.value"
        [attr.data-testid]="'theme-' + option.value + 'Btn'"
        (click)="select(option.value)"
      >
        <lib-svg-icon
          class="svg-16-no-pad"
          [icon]="option.icon"
          [stroke]="true"
        />
        {{ option.label }}
      </button>
    }
  </div>
</div>
